import {BaseGrid} from '@framewerx/kendo-angular-grid';
import {DataStateChangeEvent} from '@progress/kendo-angular-grid';

let isPatched = false;

/**
 * Patches BaseGrid state handling so partial DataStateChangeEvent payloads
 * (which may omit sort/group/filter) do not clear existing user state.
 */
export function patchFramewerxKendoAngularGridDataState(): void {
  if (isPatched) {
    return;
  }

  const baseGridPrototype = (BaseGrid as any)?.prototype;
  const originalDataStateChange = baseGridPrototype?.dataStateChange;

  if (typeof originalDataStateChange !== 'function') {
    return;
  }

  baseGridPrototype.dataStateChange = function (state: DataStateChangeEvent): void {
    const previousState = this.gridSettings?.state ?? {};
    const mergedState = {
      ...previousState,
      ...state,
      skip: state?.skip !== undefined ? state.skip : previousState.skip,
      take: state?.take !== undefined ? state.take : previousState.take,
      sort: state?.sort !== undefined ? state.sort : previousState.sort,
      group: state?.group !== undefined ? state.group : previousState.group,
      filter: state?.filter !== undefined ? state.filter : previousState.filter,
    };

    originalDataStateChange.call(this, mergedState);
  };

  isPatched = true;
}
